module.exports = __webpack_public_path__ + "img/IMG_5002_L_BlackMatted.05cf302d.jpg";